import AccueilI18n from './Accueil.i18n.js';
import ApercuPanier from './../../components/ApercuPanier/ApercuPanier.vue'
import {
    Carousel,
    Slide
} from 'vue-carousel';
import {
    mapActions,
    mapGetters
} from 'vuex';

export default {

    components: {
        Carousel,
        Slide,
        ApercuPanier
    },

    props: {},

    computed: {
        ...mapGetters(['filtres', 'groupements'])
    },

    data() {
        return {
            currentSlide: 0,
            imgSlide: [],
            resizeTime: 0,
            timeOut: false,
            resizeEndTime: 0,
            resize: null,
            alreadyResized: false
        };
    },

    watch: {},

    methods: {
        ...mapActions(['getGroupements']),

        goToFamille() {
            this.$router.push('/famille')
        },

        /**
         * Fonction pour mettre en place les parties latérales du caroussel et appliquer leurs fonds.
         * Le fond de chaque partie latérale est une répétition de la dernière bande verticale droite ou gauche de pixels.
         * @param {*} pImgPath Le chemin de l'image avec laquelle travailler.
         */
        computeCarousselLateralPart(pImgPath) {
            // Calcul de la taille des blocs latéraux
            const carousselWidth = document.getElementsByClassName('l-caroussel-img')[this.currentSlide].offsetWidth
            const screenWidth = document.getElementById('content-panel').offsetWidth
            const diffWith = screenWidth - carousselWidth
            const carousselLateralWidth = (diffWith / 2)
            document.getElementById('caroussel-lateral-left').style.width = carousselLateralWidth + 'px'
            document.getElementById('caroussel-lateral-right').style.width = carousselLateralWidth + 'px'
            // Mise en place du fond
            // Partie gauche
            let canvasLeft = document.getElementById("canvas-left")
            const ctxLeft = canvasLeft.getContext("2d")
            let imgLeft = new Image()
            const carousselHeight = document.getElementById('caroussel-lateral-left').offsetHeight
            const vm = this
            imgLeft.onload = () => {
                vm.clipImage(imgLeft, 0, 0, 1, carousselHeight, ctxLeft, canvasLeft)
                document.getElementById("caroussel-lateral-left").style.backgroundImage = "url(" + canvasLeft.toDataURL() + ")"
            }
            imgLeft.crossOrigin = "anonymous"
            imgLeft.src = pImgPath
            // Partie droite
            let canvasRight = document.getElementById("canvas-right")
            const ctxRight = canvasRight.getContext("2d")
            let imgRight = new Image()
            const imageAbsoluteWidth = 1199
            imgRight.onload = () => {
                vm.clipImage(imgRight, imageAbsoluteWidth, 0, 1, carousselHeight, ctxRight, canvasRight)
                document.getElementById("caroussel-lateral-right").style.backgroundImage = "url(" + canvasRight.toDataURL() + ")"
            }
            imgRight.crossOrigin = "anonymous";
            imgRight.src = pImgPath
        },

        /**
         * Function pour couper l'image.
         * @param {*} image L'image à couper.
         * @param {*} clipX La position X du départ de coupe.
         * @param {*} clipY La position Y du départ de coupe.
         * @param {*} clipWidth La largeur de coupe.
         * @param {*} clipHeight La hauteur de coupe.
         * @param {*} ctx Le contexte 2d de la canvas.
         */
        clipImage(image, clipX, clipY, clipWidth, clipHeight, ctx) {
            ctx.drawImage(image, clipX, clipY, clipWidth, clipHeight, 0, 0, clipWidth, clipHeight);
        },

        carousselStartMoving() {
            const imgPath = this.imgSlide[this.currentSlide].image
            this.computeCarousselLateralPart(imgPath)
        },
        /**
         * Fonction pour écouler du temps. Quand le temps est passé, la fonction de resize est appelée.
         * @param {*} func 
         * @param {*} time 
         * @returns 
         */
        debounce(func, time) {
            let timer
            return function (event) {
                if (timer) clearTimeout(timer)
                timer = setTimeout(func, time, event)
            };
        },

        /**
         * Fonction appelée quand le debounce est fini.
         */
        resizeContent() {
            this.computeCarousselLateralPart(this.imgSlide[this.currentSlide].image)
        },
        /**
         * Fonction utilisée pour le trie des images dans le caroussel.
         * @param {*} a 
         * @param {*} b 
         * @returns 
         */
        compare(a, b) {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }
            return 0;
        },
        /**
         * Fonction pour aller sur la page pointée par la banière.
         * @param {*} pImg 
         */
        goToCarouselItem(pImg) {
            // Ajout des paramètre de filtre
            if (pImg.filters) {
                pImg.filters.forEach(element => {
                    let filtreElem = {
                        libelle: element.libelle,
                        Libelle: element.libelle,
                        selected: true,
                        type: element.type
                    }
                    // Si le type contient groupement, alors on récupère la valeur
                    if (element.type === 'groupements.TYPEFLEURS') {
                        this.groupements.TYPEFLEURS.forEach(aFleur => {
                            if (aFleur.Libelle === element.libelle) {
                                filtreElem.Valeur = aFleur.Valeur
                            }
                        })
                    }
                    this.filtres.push(filtreElem)
                })
            }
            this.$router.push({
                path: pImg.link,
                query: {
                    origin: 'baniere',
                    onlyNews: pImg.onlyNews,
                    search: pImg.search
                }
            })
        }
    },

    created() {
        // Récupération de la config du caroussel depuis le fichier json.
        fetch('slider/slider.json')
            .then(response => response.json())
            .then(jsonResponse => {
                this.imgSlide = jsonResponse
                this.imgSlide = this.imgSlide.sort(this.compare)
                let vm = this
                // Attente de 150 ms avant de compiler les côtés des images.
                setTimeout(() => {
                    vm.computeCarousselLateralPart(vm.imgSlide[0].image)
                }, 150);
            })
    },

    mounted() {
        this.getGroupements().then(res => {
        }).catch(err => {
            console.log(err)
        })
        window.onresize = this.debounce(this.resizeContent, 150)
        this.lastResize = new Date()

    },

    i18n: AccueilI18n,

};
